<template>
    <img
        :src="`/static/img/${path}`"
        :height="`${height}px`"
        :width="`${width}px`"
    />
</template>

<script>
    export default {
        name: 'StaticImage',
        props: {
            path: {
                type: String,
                default: '',
            },
            height: {
                type: Number,
                default: 14,
            },
            width: {
                type: Number,
                default: 18,
            },
        },
    };
</script>
